import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useForm = (optionsToDisplay) => {
  const { addButton, editAction, deleteAction } = optionsToDisplay;
  const [listEstablishmentUser, setListEstablishmentUser] = useState([]);
  const [totalItems, setTotalItems] = useState(null);
  const [totalPages, setTotalPages] = useState(null);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { t, i18n } = useTranslation();

  const location = useLocation();
  const [query, setQuery] = useState({ page: null, order: 'firstName DESC', keyword: '', limit: 10 });

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const page = parseInt(queryParams.get('page'));
    const order = queryParams.get('order');
    const keyword = queryParams.get('keyword');
    setQuery((prev) => ({
      ...prev,
      page: page ? page - 1 : 0,
      order: order ? order : query.order,
      keyword: keyword ? keyword : '',
    }));
  }, [location]);

  useEffect(() => {
    if (query.page !== null) {
      findAllEstablishmentUsers();
    }
  }, [query]);

  const findAllEstablishmentUsers = () => {
    setLoading(true);
    AxiosInstance.get('/establishment-user', { params: query })
      .then((response) => {
        setListEstablishmentUser(response.data.items);
        setTotalPages(response.data.totalPages);
        setTotalItems(response.data.totalItems);
        setLoading(false);
      })
      .catch((error) => {
        Swal.fire(t('establishment-user.ERROR_GET_ESTABLISHMENT_USERS'), '', 'error');
        setLoading(false);
      });
  };

  const updateEstablishmentUser = (id) => {
    history.push({
      pathname: '/establishment-user/update',
      params: {
        id: id,
      },
    });
  };

  const deleteEstablishmentUser = (id) => {
    Swal.fire({
      title: t('swal.are_you_sure'),
      text: t('swal.delete_permanently'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: t('swal.yes_delete'),
      cancelButtonText: t('swal.no'),
    }).then((result) => {
      if (result.isConfirmed) {
        AxiosInstance.delete('/establishment-user/' + id)
          .then((response) => {
            Swal.fire(t('establishment-user.SUCCESS_DELETE_ESTABLISHMENT_USER'), '', 'success');
            findAllEstablishmentUsers();
          })
          .catch((error) => {
            Swal.fire(t('establishment-user.ERROR_DELETE_ESTABLISHMENT_USER'), '', 'error');
          });
      }
    });
  };

  const attributes = [
    { name: 'firstName', title: t('table.firstName'), nestedObject: ['user'], type: 'text', order: true },
    { name: 'lastName', title: t('table.lastName'), nestedObject: ['user'], type: 'text', order: true },
    { name: 'email', title: t('table.email'), nestedObject: ['user'], type: 'text', order: true },
    { name: 'name', title: t('table.nameEstablishment'), nestedObject: ['establishment'], type: 'text', order: true },
    { name: 'phone', title: t('table.phone'), nestedObject: ['user'], type: 'text', order: false },
    { name: 'creationDate', title: t('table.creationDate'), nestedObject: ['user'], type: 'date', order: false },
  ];

  const actions = {
    details: null,
    delete: deleteAction && deleteEstablishmentUser,
    update: editAction && updateEstablishmentUser,
  };

  return {
    attributes,
    actions,
    listEstablishmentUser,
    findAllEstablishmentUsers,
    totalPages,

    loading,
    query,
  };
};

export default useForm;
